import { useState } from "react";

/**
 * Represents an image component with loading spinner.
 *
 * @component
 * @param {string} src - The source URL of the image.
 * @param {string} height - The height of the image container.
 * @param {string} width - The width of the image container.
 * @param {string} size - The size of the loading spinner.
 * @param {string} alt - The alternative text for the image.
 * @param {string} opacity - The opacity of the image.
 * @param {string} fit - CSS object-fit value (default "cover").
 */

export default function Image({ src, height, width, size, alt, opacity, fit }) {
  // State to manage image loading status
  const [loading, setLoading] = useState(true);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: width ? width : "100%",
        height: height ? height : "100%",
      }}
    >
      {/* Image */}
      <img
        src={src}
        className="fadeIn"
        loading="lazy"
        decoding="async"
        style={{
          // Hidden with size 0 instead of display:none so lazy loading still triggers
          display: "block",
          width: loading ? 0 : "100%",
          height: loading ? 0 : "100%",
          objectFit: fit || "cover",
          opacity: opacity ? opacity : "1",
        }}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
        alt={alt}
      />
      {/* Loading spinner */}
      <div
        className="spinner"
        style={{
          display: loading ? "block" : "none",
          fontSize: size ? size : "24px",
        }}
      ></div>
    </div>
  );
}
